import React from 'react'

import Section from 'components/Section/Section'
import Container from 'components/Container/Container'
import PricingList from 'components/PricingList'
import { Text } from 'components/Text/Text'

const HomePricings = () => {
  return (
    <Section backgroundColor="backgroundSecundary">
      <Container size="medium">
        <Text
          style={{margin: '0 0 3rem'}}
          color="primary"
          weight="bold"
          align="center"
          preset="h3">
          Pricing That Works For You
        </Text>
        <PricingList />
      </Container>
    </Section>
  )
}

export default HomePricings
